import MiscSettings from './MiscSettings';

export default MiscSettings;
